import { IPostDetallePlantilllaVerificacion, IPostEditarPlantillaVerificacion } from "../../Interfaces/ListaVerificacion/PlantillaVerificacionDetalle/IPlantillaVerificacionDetalle";
import { fetchListVerificacion } from "../http-common";

const PostListarPlantillaVerificacionDetalle = (
  data: IPostDetallePlantilllaVerificacion
) => {
  return fetchListVerificacion.post(
    "PlantillaVerficacionDetalle/ListarDetallePlantilla",
    data
  );
};

const PostEditarPlantillaVerificacionDetalle = (data: IPostEditarPlantillaVerificacion) => {
  return fetchListVerificacion.post(
    "PlantillaVerficacionDetalle/ActualizarPlantillaVerificacion",
    data
  );
};

const PlantillaVerificacionDetalleService = {
  PostListarPlantillaVerificacionDetalle,
  PostEditarPlantillaVerificacionDetalle,
};

export default PlantillaVerificacionDetalleService;
